document.addEventListener('DOMContentLoaded', function() {
	const heroVideo = document.getElementById('hero-video');

	if (heroVideo && heroVideo.hasAttribute('data-loop-times')) {
		let loopTimes = parseInt(heroVideo.getAttribute('data-loop-times'));
		let loopCount = 0;
		heroVideo.addEventListener('ended', function () {
			if (loopCount < loopTimes-1) {
				this.currentTime = 0;
				this.play();
				loopCount ++;
			}
		}, false);
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/video-loop.js